export const GET_BUSINESS_PROFILE_WATCHER = 'GET_BUSINESS_PROFILE_WATCHER';
export const GET_BUSINESS_PROFILE_SUCCESS = 'GET_BUSINESS_PROFILE_SUCCESS';
export const GET_BUSINESS_PROFILE_FAILED = 'GET_BUSINESS_PROFILE_FAILED';
